<template>
  <div class="wrapper relative w-full h-full flex flex-1">
    <model-viewer
      v-if="objUrl"
      v-bind="feetViewerProps"
      :obj-url="objUrl"
      :measurement="currentMeasurement"
      :show-feet="feetToShow"
      :fov="25"
      style="height: 53%"
    />
    <div class="feet-control">
      <span class="lr-toggler" :class="{ active: feetToShow[0] }" @click="toggleLRFoot(0)">{{
        $t('footscan.initial_l')
      }}</span>
      <unit-switcher
        v-if="!measurementFailed"
        :use-inch="useInch"
        :layout="'white'"
        @toggle="onUnitSwitch"
      />
      <span @click="toggleLRFoot(1)" class="lr-toggler" :class="{ active: feetToShow[1] }">{{
        $t('footscan.initial_r')
      }}</span>
    </div>
    <div class="top-control left" @click="$emit('back')">
      <img class="-mt-2" src="@/assets/DefaultCloudzet/HomePage/arrow-back.svg" />
    </div>
    <div v-if="isDAF" class="top-control right" @click="showQRCode">
      <img class="-mt-2" src="@/assets/common/qr-code.svg" />
    </div>
    <analysis-panel
      @set-active="setCurrentMeasurement"
      @toggle="setCurrentMeasurement"
      :use-inch="useInch"
      :measurements="measurements"
      :active-index="activeMeasurementIndex"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VueQr from 'vue-qr';

import measurements from '@/mixins/feet-measurements';

import ModelViewer from '@/components/common/ModelViewer.vue';
import UnitSwitcher from '@/components/common/UnitSwitcher.vue';
import AnalysisPanel from '@/components/FootScan/AnalysisPanel.vue';

export default {
  name: 'FeetViewer',
  mixins: [measurements],
  components: {
    ModelViewer,
    UnitSwitcher,
    AnalysisPanel,
  },
  props: {
    tid: String,
    objUrl: String,
  },
  methods: {
    async getMeasurements() {
      try {
        this.$events.startLoading();
        const { data } = await this.$api.user.get(
          `/api/v1/scan_records/${this.tid}/size_xt`
        );
        this.processMeasurements(data, true);
      } catch (e) {
        console.log(e.message);
      } finally {
        this.$events.stopLoading();
      }
    },
    toggleLRFoot(footIndex) {
      const value = this.feetToShow[footIndex];
      this.$set(this.feetToShow, footIndex, !value);
    },
    reset() {
      this.feetToShow = [true, true];
    },
    showQRCode() {
      this.$modal.show(VueQr, this.dafQrSettings, {
        classes: 'text-center py-4',
      });
    },
  },
  watch: {
    tid: {
      async handler(nv) {
        if (nv) {
          this.reset();
          await this.getMeasurements();
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('app', ['isDAF']),
    ...mapGetters('user', ['username']),
    dafQrSettings() {
      if (!this.isDAF) return {};

      return {
        text: `${this.username},${this.tid}`,
        margin: 10,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
%safe-top {
  @screen xs {
    $margin: 1rem;
    margin-top: calc(constant(safe-area-inset-top, #{-1 * $margin}) + #{$margin});
    margin-top: calc(env(safe-area-inset-top, #{-1 * $margin}) + #{$margin});
  }
}

.wrapper {
  ::v-deep {
    .threeViewer {
      background: rgb(255, 255, 255);
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.23) 0%,
        rgba(142, 126, 189, 0.75) 100%
      );
    }
    .unit-switcher-root {
      background: white;
    }
  }
  .top-control {
    @apply absolute flex top-0 left-0 right-0 mx-auto items-center p-4;
    @extend %safe-top;
    max-height: 30px;
    max-width: 50px;
    &.left {
      @apply ml-4;
    }
    &.right {
      @apply mr-4;
    }
  }
}
.feet-control {
  @apply absolute flex justify-center items-center top-0 left-0 right-0 mx-auto;
  @extend %safe-top;
  .lr-toggler {
    @apply inline-flex justify-center items-center mx-4 text-white rounded-3xl;
    border: 1px solid white;
    width: 26px;
    height: 26px;
    font-size: 11px;
    &.active {
      @apply bg-white text-black;
    }
  }
}
</style>
